var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrangeCircleRemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#FF7925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4492 18.4294C18.4492 18.1509 18.5598 17.8838 18.7568 17.6869C18.9537 17.49 19.2207 17.3794 19.4992 17.3794C19.7777 17.3794 20.0448 17.49 20.2417 17.6869C20.4386 17.8838 20.5492 18.1509 20.5492 18.4294V24.7294C20.5492 25.0078 20.4386 25.2749 20.2417 25.4718C20.0448 25.6687 19.7777 25.7794 19.4992 25.7794C19.2207 25.7794 18.9537 25.6687 18.7568 25.4718C18.5598 25.2749 18.4492 25.0078 18.4492 24.7294V18.4294ZM19.4992 13.2539C19.2207 13.2539 18.9537 13.3645 18.7568 13.5614C18.5598 13.7584 18.4492 14.0254 18.4492 14.3039C18.4492 14.5824 18.5598 14.8495 18.7568 15.0464C18.9537 15.2433 19.2207 15.3539 19.4992 15.3539C19.7777 15.3539 20.0448 15.2433 20.2417 15.0464C20.4386 14.8495 20.5492 14.5824 20.5492 14.3039C20.5492 14.0254 20.4386 13.7584 20.2417 13.5614C20.0448 13.3645 19.7777 13.2539 19.4992 13.2539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 9C13.7009 9 9 13.7009 9 19.5C9 25.2991 13.7009 30 19.5 30C25.2991 30 30 25.2991 30 19.5C30 13.7009 25.2991 9 19.5 9ZM11.1 19.5C11.1 21.7278 11.985 23.8644 13.5603 25.4397C15.1356 27.015 17.2722 27.9 19.5 27.9C21.7278 27.9 23.8644 27.015 25.4397 25.4397C27.015 23.8644 27.9 21.7278 27.9 19.5C27.9 17.2722 27.015 15.1356 25.4397 13.5603C23.8644 11.985 21.7278 11.1 19.5 11.1C17.2722 11.1 15.1356 11.985 13.5603 13.5603C11.985 15.1356 11.1 17.2722 11.1 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrangeCircleRemark);
export default __webpack_public_path__ + "static/media/ic-orangeCircleRemark.5370de2c1bb4bb187ee21b1f86e688df.svg";
export { ForwardRef as ReactComponent };